import React from "react";
import PpcFarmCohortLedgerClient from "../../components/ppc-farm/PpcFarmCohortLedgerClient";

const PpcFarmCohortLedgerPage: React.FC = () => {
  return <PpcFarmCohortLedgerClient />;
};

export default PpcFarmCohortLedgerPage;
